import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { AREA_CAPABILITIES } from '../areaCapabilities';
import {
  CompanyEmployeesList,
  CompanyPersonnelDetail,
  AvailablePersonnelList,
  CandidateList,
  CandidateForm,
  BlacklistManager,
  HSEInductionManager,
  HRConfiguration,
  AssignmentHistoryView,
  WorkforceStatistics,
  ProjectTeamList,
  PersonnelTimesheet,
  TimesheetCodeConfig,
  TimesheetEntries,
  CorporatePayroll,
  ProjectPayroll,
  CompanyTimesheet,
  ProjectTimesheetView,
  MonthlyReports,
  CompanyPayroll,
  CompanyPersonnelForm,
  CompanyTimesheetEntries,
  PersonnelAddForm,
  KeyPersonnelList,
  PersonnelList,
  TimesheetMonth,
} from '../lazyComponents';

/** HR, payroll, timesheets, candidates, and legacy redirects. */
export function HrRoutes({ withCapability }) {
  return (
    <>
      <Route path="/hr/company/employees" element={withCapability(AREA_CAPABILITIES.hr, <CompanyEmployeesList />)} />
      <Route path="/hr/company/employees/:id" element={withCapability(AREA_CAPABILITIES.hr, <CompanyPersonnelDetail />)} />
      <Route path="/hr/company/available" element={withCapability(AREA_CAPABILITIES.hr, <AvailablePersonnelList />)} />
      <Route path="/hr/key-personnel" element={withCapability('hr.key_personnel.read', <KeyPersonnelList />)} />

      <Route path="/hr/candidates" element={withCapability(AREA_CAPABILITIES.hr, <CandidateList />)} />
      <Route path="/hr/candidates/new" element={withCapability(AREA_CAPABILITIES.hr, <CandidateForm />)} />
      <Route path="/hr/candidates/:candidateId/edit" element={withCapability(AREA_CAPABILITIES.hr, <CandidateForm />)} />
      <Route path="/hr/candidates/:candidateId" element={withCapability(AREA_CAPABILITIES.hr, <CandidateForm />)} />
      <Route path="/hr/blacklist" element={withCapability(AREA_CAPABILITIES.hr, <BlacklistManager />)} />
      <Route path="/hr/hse-induction" element={withCapability(AREA_CAPABILITIES.hr, <HSEInductionManager />)} />
      <Route path="/hr/configuration" element={withCapability(AREA_CAPABILITIES.hr, <HRConfiguration />)} />

      <Route path="/hr/reports/assignments" element={withCapability(AREA_CAPABILITIES.hr, <AssignmentHistoryView />)} />
      <Route path="/hr/reports/statistics" element={withCapability(AREA_CAPABILITIES.hr, <WorkforceStatistics />)} />

      <Route path="/hr/project/team" element={withCapability(AREA_CAPABILITIES.hr, <ProjectTeamList />)} />

      <Route path="/hr/timesheet" element={withCapability(AREA_CAPABILITIES.hr, <PersonnelTimesheet />)} />
      <Route path="/hr/timesheet/codes" element={withCapability(AREA_CAPABILITIES.hr, <TimesheetCodeConfig />)} />
      <Route path="/hr/timesheet/entries" element={withCapability(AREA_CAPABILITIES.hr, <TimesheetEntries />)} />
      <Route path="/hr/timesheet/company" element={withCapability(AREA_CAPABILITIES.hr, <CompanyTimesheet />)} />
      <Route path="/hr/payroll/company" element={withCapability(AREA_CAPABILITIES.hr, <CorporatePayroll />)} />
      <Route path="/hr/payroll/project" element={withCapability(AREA_CAPABILITIES.hr, <ProjectPayroll />)} />
      <Route path="/hr/timesheet/project" element={withCapability(AREA_CAPABILITIES.hr, <ProjectTimesheetView />)} />
      <Route path="/hr/timesheet/reports" element={withCapability(AREA_CAPABILITIES.hr, <MonthlyReports />)} />

      <Route path="/hr/company-payroll" element={withCapability(AREA_CAPABILITIES.hr, <CompanyPayroll />)} />
      <Route path="/hr/company-personnel/new" element={withCapability(AREA_CAPABILITIES.hr, <CompanyPersonnelForm />)} />
      <Route path="/hr/company-personnel/:personnelId" element={withCapability(AREA_CAPABILITIES.hr, <CompanyPersonnelDetail />)} />
      <Route path="/hr/company-timesheet" element={withCapability(AREA_CAPABILITIES.hr, <CompanyTimesheet />)} />
      <Route path="/hr/company-timesheet/entries" element={withCapability(AREA_CAPABILITIES.hr, <CompanyTimesheetEntries />)} />

      <Route path="/hr" element={<Navigate to="/hr/company/employees" replace />} />
      {/* ETAPA 5a: `/hr/personnel` deja de ser un redirect y pasa a ser LA
          pantalla unica de personal -- contratados y ex-trabajadores, abriendo
          en los activos. Las dos viejas siguen vivas: esta etapa anade, no
          quita, y quitarlas es la segunda parte. */}
      <Route path="/hr/personnel" element={withCapability(AREA_CAPABILITIES.hr, <PersonnelList />)} />
      <Route path="/hr/timesheet/month" element={withCapability(AREA_CAPABILITIES.hr, <TimesheetMonth />)} />
      <Route path="/hr/personnel/add" element={<Navigate to="/hr/candidates" replace />} />
      <Route path="/hr/personnel/add/:candidateId" element={withCapability(AREA_CAPABILITIES.hr, <PersonnelAddForm />)} />
      <Route path="/hr/personnel/assignments" element={<Navigate to="/hr/reports/assignments" replace />} />
      <Route path="/hr/personnel/statistics" element={<Navigate to="/hr/reports/statistics" replace />} />
      <Route path="/hr/personnel/:personnelId" element={withCapability(AREA_CAPABILITIES.hr, <CompanyPersonnelDetail />)} />
    </>
  );
}
